import SelectDateFromTo, { SelectDateFromToRef } from "./SelectDateFromTo"
import { useEffect } from "react"

const refSelectDateFromToByIndex: Record<number, SelectDateFromToRef | null> = {}

export const getRefSelectDateFromTo = (indexInputFlight: number) => {
  return refSelectDateFromToByIndex[indexInputFlight] || null
}

const SelectDateFromToWrapper = (props: any) => {
  useEffect(() => {
    return () => {
      delete refSelectDateFromToByIndex[props.indexInputFlight]
    }
  }, [props.indexInputFlight])

  return (
    <SelectDateFromTo
      ref={(curr) => { refSelectDateFromToByIndex[props.indexInputFlight] = curr; }}
      {...props}
    />
  )
}
export default SelectDateFromToWrapper